const ieCheck = {
	init () {
    $(window).on('load', function () {
      var d = document;
      var b = d.body;
      var s = b.style;
      var ieVersion = null;
      var property;
      // Test IE11 properties
      property = 'msTextCombineHorizontal';
      console.log('Property: '+s[property]);
      if (s[property] !== undefined) {
        ieVersion = 'ie11';
        console.log(ieVersion);
        $('body').addClass('ie-check');
      }
    });
  }
};

export default ieCheck;



// WEBPACK FOOTER //
// ./src/components/01-elements/ie-check/ie-check.js